const pkg = state => state.pkg
const app = state => state.app
const authenticated = state => state.app.authenticated
const device = state => state.app.device
const sidebar = state => state.app.sidebar
const effect = state => state.app.effect
const timesheetPage = state => state.app.timesheetPage
const allowanceSwitch = state => state.app.allowanceSwitch
const menuitems = state => state.menu.items
const componententry = state => {
  return state.menu.items.filter(c => c.meta && c.meta.label === 'Components')[0]
}
const eventcount = state => state.app.eventCount
const timesheetStatus = state => state.app.timesheetStatus
const datetimeTimesheet = state => state.app.datetimemytimesheet
const datetimeOTStatus = state => state.app.datetimeotstatus
const datetimeTotalOT = state => state.app.datetimetotalot
const datetimeTimesheetList = state => state.app.datetimetimesheetlist

export {
  pkg,
  app,
  authenticated,
  device,
  sidebar,
  effect,
  menuitems,
  timesheetPage,
  componententry,
  eventcount,
  timesheetStatus,
  datetimeTimesheet,
  datetimeOTStatus,
  datetimeTotalOT,
  datetimeTimesheetList,
  allowanceSwitch
}



// WEBPACK FOOTER //
// ./client/store/getters.js